// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2KHI9","item":"PaymentsMobile_item__9Jowh","label":"PaymentsMobile_label__1etJS","amount":"PaymentsMobile_amount__33_IB"};